import React from 'react';
import styled from 'styled-components';
import { Text } from '../UI/Typography';
import LoginTab from './LoginTab';
import RegistrationWizard from './AuthComponents/RegistrationWizard';

const TabContainer = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const TabButtons = styled.div`
  display: flex;
  border-bottom: 2px solid ${({ theme }) => theme.colors.border};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const TabButton = styled.button`
  flex: 1;
  padding: ${({ theme }) => theme.spacing.md};
  border: none;
  background: transparent;
  font-size: ${({ theme }) => theme.typography.fontSizes.md};
  font-weight: ${({ theme }) => theme.typography.fontWeights.semibold};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ active, theme }) => 
    active ? theme.colors.primary : theme.colors.text.secondary
  };
  border-bottom: 2px solid ${({ active, theme }) => 
    active ? theme.colors.primary : 'transparent'
  };
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => `${theme.colors.primary}10`};
  }
`;

const TabContent = styled.div`
  width: 100%;
  font-family: ${({ theme }) => theme.typography.fontFamily};
`;

const AuthTabs = ({ onLogin, isLoading, error, activeTab, setActiveTab }) => {
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleRegistrationComplete = (result) => {
    console.log('Full registration completed:', result);
    // Switch to login tab after successful completion
    setActiveTab('login');
  };

  return (
    <TabContainer>
      <TabButtons>
        <TabButton 
          active={activeTab === 'login'}
          onClick={() => handleTabChange('login')}
        >
          <Text size="md" weight="semibold" style={{ margin: 0, color: 'inherit' }}>
            Login
          </Text>
        </TabButton>
        <TabButton 
          active={activeTab === 'register'}
          onClick={() => handleTabChange('register')}
        >
          <Text size="md" weight="semibold" style={{ margin: 0, color: 'inherit' }}>
            Register
          </Text>
        </TabButton>
      </TabButtons>

      <TabContent>
        {activeTab === 'login' ? (
          <LoginTab 
            onLogin={onLogin}
            isLoading={isLoading}
            error={error}
          />
        ) : (
          <RegistrationWizard 
            onComplete={handleRegistrationComplete}
          />
        )}
      </TabContent>
    </TabContainer>
  );
};

export default AuthTabs;